<section class="cmn-innerpage-wrapper">
<div class="tab-content-wrapper">
    <form [formGroup]="serviceForm" > 
      <div class="employee-form-wrapper">
    <div class="grid-wrapper-4">
          <div class="form-wrapper">
            <label for="">Service Name <span class="red">*</span></label>
            <mat-form-field>
              <input matInput placeholder="Enter Service Name" formControlName="serviceName" maxlength="45" />
    
            </mat-form-field>
            <div class="custom-error" *ngIf="
            serviceForm.get('serviceName')?.invalid &&
            serviceForm.get('serviceName')?.touched
          ">
              <span>
                <mat-error *ngIf="serviceForm.get('serviceName')!.touched &&
                    serviceForm.get('serviceName')!.hasError('required')">Service name is required</mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Service Code <span class="red">*</span></label>
            <mat-form-field>
              <input matInput placeholder="Enter Service Code" formControlName="serviceCode" maxlength="45" />
    
            </mat-form-field>
            <div class="custom-error" *ngIf="
            serviceForm.get('serviceCode')?.invalid &&
            serviceForm.get('serviceCode')?.touched
          ">
              <span>
                <mat-error *ngIf="serviceForm.get('serviceCode')!.touched &&
                    serviceForm.get('serviceCode')!.hasError('required')">Service code is required</mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Description<span class="red">*</span></label>
            <mat-form-field>
              <input matInput placeholder="Enter description" formControlName="description" maxlength="45" />
    
            </mat-form-field>
            <div class="custom-error" *ngIf="
            serviceForm.get('description')?.invalid &&
            serviceForm.get('description')?.touched
          ">
              <span>
                <mat-error *ngIf="serviceForm.get('description')!.touched &&
                    serviceForm.get('description')!.hasError('required')">Description is required</mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Department <span class="red">*</span></label>
            <mat-form-field>
              <mat-select placeholder="Select Department" formControlName="departmentId" (selectionChange)="onDepartmentChange($event)">
                <mat-option *ngFor="let dept of departmentData" [value]="dept.id">
                  {{ dept.departmentName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error *ngIf="
                serviceForm.get('departmentId')!.touched &&
                serviceForm.get('departmentId')!.hasError('required')
              ">Department is required.</mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <span>
                <label for="">Employee Name <span class="red">*</span></label>
            </span>
            <mat-form-field>
                <mat-select placeholder="Select Employee" formControlName="employeeId">
                    <mat-option *ngFor="let employee of employees" [value]="employee?.id">
                        {{ employee?.firstName }}
                    </mat-option>
                </mat-select> </mat-form-field>
            <div class="custom-error">
                <span>
                    <mat-error *ngIf="
                     serviceForm.get('employeeId')!?.touched &&
                     serviceForm.get('employeeId')?.hasError('required')">
                        Employee is required
                    </mat-error>
                </span>
            </div>
        </div>
  
          <div class="chart-account-form-wrapper">
            <div class="form-wrapper">
              <label for="">Task Name <span class="red">*</span></label>
              <mat-form-field>
                <mat-select placeholder="Select Task" formControlName="taskName">
                  <mat-option *ngFor="let task of taskData" [value]="{id: task?.id, name: task?.taskName}">
                    {{ task?.taskName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <button class="cmn-next-btn" type="button" (click)="addChecklist(serviceForm.get('taskName')?.value)">
              <img src="assets/images/icons/icon-add-color.svg" alt="Add Stock" />
              Add Task
            </button>
          </div>
    </div>

        <div class="item-service-adding-table-wrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Task Name</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody cdkDropList (cdkDropListDropped)="dropItem($event)">
              <tr *ngFor="let item of itemArray; let i = index; trackBy: trackByIndex" cdkDrag>
                <td> 
                  <label class="checkbox-wrapper">
                    <input
                      type="checkbox"
                      [(ngModel)]="item.isMandatory"
                      [ngModelOptions]="{ standalone: true }"
                      [name]="'isMandatory_' + i"
                    />
                    <span class="checkmark"></span>
                  </label>
                </td>
                <td>{{ item.taskName || item.taskData?.taskName }}</td>
                <td>
                  <div class="action-wrapper">
                    <img src="../../../assets/images/icons/icon-delete.svg" alt="Delete" (click)="onRemoveItem(i)" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      
        
      </div>
      <div class="submit-btn-wrapper flex-middle">
        <button class="cmn-next-btn" (click)="onAddTask()" [disabled]="loading">
          <span *ngIf="!loading">{{taskData?.id ? 'Save':'Add Service'}}</span>
          <span *ngIf="loading">Loading...</span>
        </button>
      </div>
    </form>
  </div>
</section>